import React from "react";
import "./style.scss";

const LoadMoreComponent = ({ children, isShow, handleChange, label }) => {
  return (
    <div className="load_more_container">
      <div>{isShow && children}</div>
      {!isShow && (
        <button onClick={handleChange} className="load_more_btn iran-sans_Bold">
          {label}
        </button>
      )}
    </div>
  );
};

export default LoadMoreComponent;
